import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';
import { UserSessionService } from '../services/user-session.service';
import { List } from 'linqts';
import { DiffChangeoverType, LineDiff, DiffLineProduct, DiffLineTask } from '../../models/line-diff';

@Component({
  selector: 'app-line-setup',
  templateUrl: './line-setup.component.html',
  styleUrls: ['./line-setup.component.scss']
})
export class LineSetupComponent implements OnInit {
  lineDiffFetchPromise: Promise<LineDiff> | null = null;
  lineDiff: LineDiff | null = null;

  applyChangesPromise: Promise<void> | null = null;

  diffWorkbookFile: File | null = null;

  lineProducts: DiffLineProduct[] = [];
  addedLineProductCount: number = 0;
  removedLineProductCount: number = 0;
  lineTasks: DiffLineTask[] = [];
  addedLineTaskCount: number = 0;
  removedLineTaskCount: number = 0;
  changoverTypes: DiffChangeoverType[] = [];
  addedChangeoverTypeCount: number = 0;
  modifiedChangeoverTypeCount: number = 0;
  removedChangeoverTypeCount: number = 0;
  changesApplied: boolean = false;

  constructor(
    private apiService: ApiService,
    private userSessionService: UserSessionService
  ) {
  }

  ngOnInit(): void {
  }

  onFileSelected = async (event: Event) => {
    const file = (event.target as HTMLInputElement).files![0];
    // This handler is only called when 'value' changes.
    // We null it here to ensure the handler is called even if the user tries to upload the same file twice.
    (event.target as HTMLInputElement).value = null!;

    this.diffWorkbookFile = null;
    this.lineDiff = null;

    try {
      this.changesApplied = false;
      this.applyChangesPromise = null;
      this.lineDiffFetchPromise = this.apiService.previewLineSetupChanges(file);
      const diff = await this.lineDiffFetchPromise;

      this.processLineDiff(diff);
      this.diffWorkbookFile = file;

      this.lineDiffFetchPromise = null;
    } catch {
    }
  }

  private async processLineDiff(diff: LineDiff) {
    this.lineDiff = diff;

    const lineProducts = new List(this.lineDiff.lineProducts);
    this.lineProducts = lineProducts.OrderBy(item => item.name).ThenBy(item => item.isNew).ThenBy(item => item.isRemoved).ToArray();
    this.addedLineProductCount = lineProducts.Count(item => item!.isNew);
    this.removedLineProductCount = lineProducts.Count(item => item!.isRemoved);

    const lineTasks = new List(this.lineDiff.lineTasks);
    this.lineTasks = lineTasks.ToArray();
    this.addedLineTaskCount = lineTasks.Count(item => item!.isNew);
    this.removedLineTaskCount = lineTasks.Count(item => item!.isRemoved);

    const changeoverTypes = new List<DiffChangeoverType>(this.lineDiff.changeoverTypes);
    this.changoverTypes = changeoverTypes.OrderBy(item => item.ingestionNumber).ThenBy(item => item.isNew).ThenBy(item => item.isModified).ThenBy(item => item.isRemoved).ToArray();
    this.addedChangeoverTypeCount = changeoverTypes.Count(item => item!.isNew);
    this.modifiedChangeoverTypeCount = changeoverTypes.Count(item => item!.isModified);
    this.removedChangeoverTypeCount = changeoverTypes.Count(item => item!.isRemoved);
  }

  applyChanges = async (event: Event) => {
    this.applyChangesPromise = null;
    if (this.diffWorkbookFile) {
      try {
        this.applyChangesPromise = this.apiService.applyLineSetup(this.diffWorkbookFile);
        await this.applyChangesPromise;
        this.changesApplied = true;
        this.applyChangesPromise = null;
      }
      catch { }
    }
  }
}
